module.exports = __webpack_public_path__ + "static/media/projects-paper.767688fa.svg";